import { Component, OnInit } from '@angular/core';
import { PlayerService } from './services/player.service';
import { ScrollService, AuthService, SongsService } from '../api/';
import { HumanTime } from '../human-time.pipe';

@Component({
  selector: 'player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.css']
})
export class PlayerComponent implements OnInit {
  private firstPlay = false;
  private belongsToRadio = false;
  private song = null;
  private nextsong = null;
  public que: boolean = true;
  private position: number = 0;
  private duration: number = 0;
  private durationRadioSong: any = 0;
  private playerEventSubscriber = null;
  public onlineOffline: boolean = navigator.onLine;
  public trackingCounter = 0;
  public totalTime = 0;
  public showMore = false;
  public completeSecond = 0;

  constructor(private songsService: SongsService, private playerService: PlayerService, private scrollService: ScrollService, private authService: AuthService) {
    window.addEventListener('online', () => { this.onlineOffline = true; });
    window.addEventListener('offline', () => { this.onlineOffline = false });
  }

  ngOnInit() {
    let check = true;
    if (this.onlineOffline) {
      this.playerService.playerEvent.subscribe((event) => {
        // to separate the timeLog of each song we set the trackingCounter to 0
        this.trackingCounter = 0;
        // ad logo adjustment.
        let links = document.querySelectorAll('#playerid a');
        let i, href;
        for (i = 0; i < links.length; i++) {
          href = links[i].getAttribute('id');
          if (href == "lb-anchor-link") {
            links[i].setAttribute("style", "width: 0px !important;")
          }
        }
        if (event.type === 'currentTrack:position') {
          this.position = event.data;
          let min = (this.position / 1000 / 60) << 0,
          sec = Math.round((this.position / 1000) % 60);
          let second = (min * 60) + sec;
          if (second > 0) {
            // count the timeLog of each song separately
            this.trackingCounter = this.totalTime + 0.25;
          }
          // to send logTime request if the song ends or the user switch the song
          if (Math.round(this.position) >= this.duration && this.duration != 0 && this.duration != null) {
            this.playerService.logTimePlayed(this.totalTime);
            this.playerService.listenToSongCount.next(true);
          } else if (this.playerService.isPlayingStatus() == false) {
            // to keep the track of the timelog when user switch the song, the time value becomes one so temp keep tracks of the value
            if (this.totalTime != 0) {
              var temp = this.totalTime;
              this.playerService.logTimePlayed(temp);
              this.playerService.listenToSongCount.next(true);
            }
          }
          // keep the value of the tracking counter each time and store it in totalTime then use it above
          this.totalTime = this.trackingCounter;
          if(this.totalTime == 59) {
            this.playerService.timeRestriction.next(true);
          }
          if (second > 0 && (second % 5) == 0 && check && this.completeSecond != second) {
            check = false;
            this.playerService.logTimePlayed(this.totalTime);
            this.playerService.listenToSongCount.next(true);
          } else {
            check = true;
          }
          this.completeSecond = second;
          if (second == 2) {
            let lb_anchor = document.getElementById("lb-anchor-link");
            if (lb_anchor != null) {
              lb_anchor.onclick = function () {
                document.getElementById("adClickEvet").click();
              };
            }
          }
        }
        if (event.type === 'currentTrack:duration') {
          if (event.data != 0) {
            this.duration = event.data;
          } else if (localStorage.getItem('Duration')) {
            this.durationRadioSong = localStorage.getItem('Duration');
          } else {
            this.durationRadioSong = 0;
          }
        }
        if (event.type === 'track:id') {
          this.firstPlay = true;
          this.song = this.playerService.currentTrackData();
          this.nextsong = this.playerService.currentTrackData2();
          if (this.playerService.currentTrackData()) {
            this.belongsToRadio = (this.playerService.currentTrackData().belongsToRadio)
              ? this.playerService.currentTrackData().belongsToRadio : false;
          }
        }
      });
    }
  }

  logAdClick() {
    this.songsService.adLogging(this.playerService.playingId).subscribe((res) => {
    });
  }

  openSideNav(type: string) {
    this.scrollService.openSideNav(type);
  }

  closeSideNav() {
    this.que = true;
    this.scrollService.closeSideNav();
  }

  // On Show more control icon
  onShowMore() {
    this.showMore = !this.showMore;
  }

}



// WEBPACK FOOTER //
// ./src/app/player/player.component.ts